import { render, staticRenderFns } from "./ABtestList.vue?vue&type=template&id=3ba0168a"
import script from "./ABtestList.vue?vue&type=script&lang=js"
export * from "./ABtestList.vue?vue&type=script&lang=js"
import style0 from "./ABtestList.vue?vue&type=style&index=0&id=3ba0168a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports